module.exports = __webpack_public_path__ + "img/75.670e26a0.jpg";